import React, { useRef, useState, useEffect } from "react";
import { CSVLink } from "react-csv";
//import "./index.scss";
import { toast } from "react-toastify";

const AzureB2CUploadCsvForm = () => {
  const CSV_URL = "sitecore/shell/B2C/AdminManagement/ImportAzureB2CCsv";
  const GET_URL = "/AdminManagement/GetAllRequestUserListAsync";
  const GET_COUNT = "/AdminManagement/GetStatusCountAsync";
  const [count, setCount] = useState({});
  const [userList, setuserList] = useState([]); // Initialize as empty array for CSVLink
  const [typeError, setTypeError] = useState(null);
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  // Helper to fetch user list
  const fetchUserList = async () => {
    try {
      const userListResponse = await fetch(GET_URL);
      if (!userListResponse.ok) {
        throw new Error(
          `HTTP error fetching user list! Status: ${userListResponse.status}`,
        );
      }
      const userListData = await userListResponse.json();
      setuserList(userListData);
    } catch (error) {
      console.error("Error fetching user list:", error);
      // Optionally toast.error("Failed to load user list.");
    }
  };

  const handleFileChange = async e => {
    const file = e.target.files[0];
    setTypeError(null); // Clear previous errors

    if (!file) return;

    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-excel", // .xls and some CSVs
      "text/csv", // .csv
    ];

    if (!allowedTypes.includes(file.type)) {
      setTypeError(
        `Invalid file type: ${file.type}. Please upload a .csv, .xls, or .xlsx file.`,
      );
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    try {
      const res = await fetch(CSV_URL, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(
          errorData.message || `HTTP error! Status: ${res.status}`,
        );
      }
      const responseData = await res.json();
      console.log("res", responseData);
      toast.success("Upload successful");

      // Refetch user list after successful upload
      await fetchUserList();
      await handleGetCount(); // Refetch counts too
    } catch (err) {
      console.error("err", err);
      toast.error(
        "Upload failed: " + (err.message || "An unknown error occurred"),
      );
    }
  };

  const handleGetCount = async () => {
    try {
      const res = await fetch(GET_COUNT);
      if (!res.ok) {
        throw new Error(`HTTP error fetching count! Status: ${res.status}`);
      }
      const data = await res.json(); // Await the JSON parsing

      console.log("response", data);
      setCount(data); // Set state with the parsed data
    } catch (error) {
      console.error("Error fetching count:", error);
      toast.error("Failed to load user summary count.");
    }
  };

  useEffect(() => {
    handleGetCount();
    fetchUserList(); // Fetch list on initial load for the CSVLink
  }, []);

  console.log("count", count);

  return (
    <>
      <div className="csvHeader">
        <div className="userList">
          Summary: {count.approvedCount} Approved / {count.pendingCount} Pending
          / {count.deactivatedCount} Deactivated / {count.rejectCount} Rejected
        </div>
        <div className="export">
          <input
            type="file"
            accept=".xls,.xlsx,.csv"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          {/* DISPLAY THE ERROR HERE */}
          {typeError && (
            <div className="alert alert-danger" role="alert">
              {typeError}
            </div>
          )}
          <ul>
            <li onClick={handleClick}>
              <span>Import Users (.csv)</span>
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.5 12L10.5 8V11H2.5V13H10.5V16M20.5 18V6C20.5 5.46957 20.2893 4.96086 19.9142 4.58579C19.5391 4.21071 19.0304 4 18.5 4H6.5C5.96957 4 5.46086 4.21071 5.08579 4.58579C4.71071 4.96086 4.5 5.46957 4.5 6V9H6.5V6H18.5V18H6.5V15H4.5V18C4.5 18.5304 4.71071 19.0391 5.08579 19.4142C5.46086 19.7893 5.96957 20 6.5 20H18.5C19.0304 20 19.5391 19.7893 19.9142 19.4142C20.2893 19.0391 20.5 18.5304 20.5 18Z"
                  fill="white"
                />
              </svg>
            </li>

            <CSVLink
              data={userList || []}
              filename={"my-file.csv"}
              className="btn btn-primary"
              target="_blank"
            >
              <li>
                <span>Export Users (.csv)</span>
              </li>
            </CSVLink>
          </ul>
        </div>
      </div>
    </>
  );
};

export default AzureB2CUploadCsvForm;
